export const requiredLabel = label => `${label} *`

export const optionalLabel = label => `${label} (optional)`

export const SECOND_TITLE_PLACEHOLDER = 'e.g. Main price list'

export const SECOND_TITLE_HELPER_TEXT =
  'The name for this price list. Title is the supplier name; use this to tell multiple lists from the same supplier apart — it usually matches the supplier’s price file name.'

export const DEFAULT_ACCOUNT_NUMBER_PLACEHOLDER = 'e.g. ACC-001'

export const DEFAULT_ACCOUNT_NUMBER_HELPER_TEXT =
  'This default account number is applied to venues when you switch this supplier on. If venues need their own account number, set it under each venue’s Your Suppliers tab.'

export const LOGO_URL_PLACEHOLDER = 'https://example.com/supplier-logo.png'

export const LOGO_URL_HELPER_TEXT =
  'Enter a real image URL for this supplier’s logo (PNG or JPG). A placeholder or OMS logo will not be used — you must provide the supplier’s own logo link.'
